// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"99":"e722c5b4","313":"7b32bf8c","915":"5b83a8bc","922":"35d6416d"}[chunkId] + ".css";
};